let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToId = (target) => {
  const id = target === "termin" && window.innerWidth < 1024 ? "termin-formular" : target;
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.resize();
    lenis.scrollTo(el, { offset: -72, duration: 1.5 });
  } else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const resetScroll = () => {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  window.scrollTo(0, 0);
};

export const EASE = [0.22, 1, 0.36, 1];
